<template>
  <nav>
    <router-link :to="`/${$store.state.language}`" :class="['row center', mode]">
      <i class="fa-solid fa-icicles"></i>
      <h2>
        <span>arctic</span>
        <span>reply</span>
      </h2>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    mode: { type: String, default: 'dark' },
  },
  setup() {},
}
</script>

<style lang="scss" scoped>
a {
  &.light {
    color: var(--base);
  }

  &.dark {
    color: var(--dark-10);
  }

  i {
    font-size: 1.75rem;
    margin-right: 10px;
  }

  h2 {
    margin: 0;

    span {
      &:first-of-type {
        color: var(--arctic);
      }
    }
  }
}
</style>
